export interface CodeSign {
  endOfInstruction: string
  stringSign: string
}

const DEFAULT: CodeSign = { endOfInstruction: ';', stringSign: '"' }

const BY_TECH: Record<string, Partial<CodeSign>> = {
  npm: { endOfInstruction: '', stringSign: "'" },
  pypi: { endOfInstruction: '', stringSign: "'" },
  ruby: { endOfInstruction: '', stringSign: "'" },
  packagist: { endOfInstruction: ';', stringSign: "'" },
}

export function getCodeSigns(technology: string): CodeSign {
  return { ...DEFAULT, ...BY_TECH[technology] }
}
